export type FaceEmotionSample = {
  joy: number;
  sorrow: number;
  anger: number;
};

const samples: FaceEmotionSample[] = [];

export function recordFaceEmotions(sample: FaceEmotionSample): void {
  samples.push(sample);
}

export function getAverageFaceEmotions(): FaceEmotionSample {
  if (samples.length === 0) {
    return { joy: 0.5, sorrow: 0, anger: 0 };
  }
  const total = samples.reduce(
    (acc, s) => ({
      joy: acc.joy + s.joy,
      sorrow: acc.sorrow + s.sorrow,
      anger: acc.anger + s.anger,
    }),
    { joy: 0, sorrow: 0, anger: 0 }
  );
  const n = samples.length;
  return {
    joy: total.joy / n,
    sorrow: total.sorrow / n,
    anger: total.anger / n,
  };
}

export function resetFaceEmotions(): void {
  samples.length = 0;
}
